// Angebot eines Standorts (Entscheidung F08): Der Standort übernimmt die globalen
// Unterrichtsformen und Pakete, bis er eine Abweichung anlegt. `null` in einem Feld
// heißt „wie global"; sind alle Felder null, verschwindet die Abweichung.

import { api } from './core';

export interface FormWerte {
  aktiv: boolean | null;
  aufnahmegebuehr_cents: number | null;
}

export interface PaketWerte {
  aktiv: boolean | null;
  sofortpreis_cents: number | null;
  grundpreis_cents: number | null;
  reihenfolge: number | null;
}

export interface AngebotPaket {
  package_id: string;
  name: string;
  einheiten: number;
  global: PaketWerte;
  abweichung: PaketWerte;
  wirksam: PaketWerte;
}

export interface AngebotForm {
  id: number;
  name: string;
  dauer_minutes: number | null;
  max_schueler: number | null;
  global: FormWerte;
  abweichung: FormWerte;
  wirksam: FormWerte;
  pakete: AngebotPaket[];
}

export interface StandortAngebot {
  standort_id: number;
  unterrichtsformen: AngebotForm[];
  pakete_ohne_form: AngebotPaket[];
}

export const standortAngebotApi = {
  get: (standortId: number) => api.get<StandortAngebot>(`/api/standorte/${standortId}/angebot`),
  setForm: (standortId: number, formId: number, werte: Partial<FormWerte>) =>
    api.put<StandortAngebot>(
      `/api/standorte/${standortId}/angebot/unterrichtsformen/${formId}`,
      werte,
    ),
  setPaket: (standortId: number, packageId: string, werte: Partial<PaketWerte>) =>
    api.put<StandortAngebot>(
      `/api/standorte/${standortId}/angebot/pakete/${encodeURIComponent(packageId)}`,
      werte,
    ),
};

export const euroAusCents = (cents: number | null | undefined): string =>
  cents == null ? '' : (cents / 100).toFixed(2).replace('.', ',');

export const centsAusEuro = (text: string): number | null => {
  const normalisiert = text.trim().replace(',', '.');
  if (normalisiert === '') return null;
  const wert = Number(normalisiert);
  if (!Number.isFinite(wert) || wert < 0) return null;
  return Math.round(wert * 100);
};
